module.exports = __webpack_public_path__ + "static/media/logo akad berwarna.336a385b.png";